<template>
  <div style="overflow-x: scroll;">
    <table class="table table-hover table-bordered" style="width:auto">
      <thead>
      <th>&nbsp;</th>

      <th
        v-for="fill in fills"
        :key="'fill-' + fill.id"
        class="px-1 text-center">
        <small>{{ fill.title }}</small>
      </th>
      </thead>
      <tbody
        v-for="info in data"
        :key="info.catalog.id">
      <th :colspan="fills.length + 1" class="py-2">
        {{ info.catalog.name }}
      </th>
      <tr
        v-for="item in info.items"
        :key="item.id">
        <td style="width: 400px !important;" class="text-nowrap py-2">
          {{ item.title }}
        </td>

        <td
          v-for="fill in fills"
          :key="'fill-' + fill.id"
          class="p-0">
          <div v-for="field in item.fields" :key="field.id" class="p-0">
            <div
              v-if="fill.answers[field.id]"
              :class="'px-1 py-2 text-center text-nowrap checkup-strength-' + field.strength">
              <div
                v-if="fill.answers[field.id]"
                style="width:50px;overflow:hidden;margin: auto;">
                <small v-if="field.type === 'check'" :title="field.label">
                  {{ field.label }}
                </small>

                <small v-else :title="fill.answers[field.id]">
                  {{ fill.answers[field.id] }}
                </small>
              </div>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import formatDate from '../../../utils/formatDate';

export default {
  name: 'CheckupCalendar',

  props: ['prescriptions', 'catalogs', 'items', 'answers'],

  data() {
    return {};
  },

  computed: {
    fills() {
      const fills = this.answers.map(fill => {
        const {id, createdAt} = fill;
        const date = new Date(createdAt);
        const sort = formatDate(date, 'ymd');
        const title = formatDate(date, 'd.m.y');
        const answers = {};

        fill.answers.forEach(({field, value}) => {
          answers[field] = value;
        });

        return {id, sort, title, answers};
      });

      fills.sort((a, b) => a.sort - b.sort);

      return fills;
    },

    data() {
      const result = [];
      const items = this.prescriptions.map(prescription => prescription.item);

      for (const catalog of this.catalogs) {
        const data = {catalog, items: []};

        for (const item of this.items) {
          if (item.catalog === catalog.id && items.includes(item.id)) {
            data.items.push(item);
          }
        }

        if (data.items.length === 0) {
          continue;
        }

        data.items.sort((a, b) => a.sort - b.sort);

        result.push(data);
      }

      result.sort((a, b) => a.catalog.sort - b.catalog.sort);

      return result;
    },
  },

  methods: {},
};
</script>
